import { cn } from '@/lib/utils';
import { assertFilled } from './dev-invariants';

export type WatermarkProps = {
  word: string;
  className?: string;
};

/**
 * Watermark — the oversized dossier-plate ornament word (R4-P2 build brief
 * §2, dossier §1.3 recipe E). Absolutely positioned, decorative, never
 * interactive. Used by `FigureFrame` mode E; a caller supplies its own
 * positioning offsets via `className` (Watermark itself only owns the
 * `absolute` base — no default inset, since its anchor differs per host).
 */
export function Watermark({ word, className }: WatermarkProps) {
  assertFilled(word.trim().length > 0, 'Watermark: word must be non-blank.');

  return (
    <span
      data-primitive="Watermark"
      data-slot="watermark"
      data-type-role="primary"
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute select-none whitespace-nowrap font-semibold leading-none',
        'text-[clamp(110px,18vw,248px)] tracking-[-0.03em] text-[#F5F6F7] opacity-[.18]',
        className
      )}
    >
      {word}
    </span>
  );
}
